import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonSizes, ButtonTypes } from '@leegality/leegality-react-component-library';
import { IconColors, IconKeys, iconRenderer } from '@components/icon';
import { getTranslation } from '@utils';

const BackButton = ({ onClick, className }) => (
  <Button
    type={ButtonTypes.SECONDARY}
    size={ButtonSizes.SMALL}
    borderLess
    ariaLabel={getTranslation('BACK_LABEL')}
    renderIcon={() => iconRenderer({ iconName: IconKeys.ChevronLeft, size: 20, color: IconColors.GRAY })}
    onClick={onClick}
    className={className}
  />
);

BackButton.defaultProps = {
  className: '',
};

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default BackButton;
